import { theme } from "kosmos-ui/lib";
import { TVectorProps } from "kosmos-ui/lib/types/vectors";

function AnalyticsIcon({ height = "100px", style }: TVectorProps) {
  return (
    <svg height={height} viewBox="0 0 100 100" style={style}>
      <defs>
        <linearGradient id="gradient">
          <stop stopColor={theme.colorsPalette.yellow.default} offset="0%" />
          <stop stopColor={theme.colorsPalette.yellow.default} offset="100%" />
        </linearGradient>
      </defs>

      <path
        fill={theme.colorsPalette.blue.default}
        d="M18.5,86.5c-1.9,0-3.5-1.6-3.5-3.5V47c0-1.9,1.6-3.5,3.5-3.5S22,45.1,22,47v36C22,84.9,20.4,86.5,18.5,86.5z"
      />
      <path
        fill={theme.colorsPalette.blue.default}
        d="M38.5,86.5c-1.9,0-3.5-1.6-3.5-3.5V35c0-1.9,1.6-3.5,3.5-3.5S42,33.1,42,35v48C42,84.9,40.4,86.5,38.5,86.5z"
      />
      <path
        fill={theme.colorsPalette.blue.default}
        d="M60.5,86.5c-1.9,0-3.5-1.6-3.5-3.5V47c0-1.9,1.6-3.5,3.5-3.5S64,45.1,64,47v36C64,84.9,62.4,86.5,60.5,86.5z"
      />
      <path
        fill={theme.colorsPalette.blue.default}
        d="M81.5,86.5c-1.9,0-3.5-1.6-3.5-3.5V17c0-1.9,1.6-3.5,3.5-3.5S85,15.1,85,17v66C85,84.9,83.4,86.5,81.5,86.5z"
      />
    </svg>
  );
}

export default AnalyticsIcon;
